module.exports = "/layout/app/images/text-meet-veelloman.72096b30.svg";